module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_MURS_PAPIER_BRIQUE_BLANCHE.5d70f7b3.webp";